import api from "./Api";

class FornecedorTelefoneService {
  GetFornecedorTelefone(payload) {
    return api.get("/v1/fornecedorTelefone/" + payload).then((response) => {
      return response.data;
    });
  }

  PostFornecedorTelefone(payload) {
    return api.post("/v1/fornecedorTelefone/", payload).then((response) => {
      return response.data;
    });
  }

  PutFornecedorTelefone(payload) {
    return api.put("/v1/fornecedorTelefone/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteFornecedorTelefone(payload) {
    return api.delete("/v1/fornecedorTelefone/" + payload).then((response) => {
      return response.data;
    });
  }

  GetFornecedorTelefoneOData(payload) {
    return api.get("/OData/FornecedorTelefone" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new FornecedorTelefoneService();
